import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/etsy': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M384 348c-1.8 10.8-13.8 110-15.5 132-117.9-4.3-219.9-4.7-368.5 0v-25.5c45.5-8.9 60.6-8 61-35.3 1.8-72.3 3.5-244.1 0-322-1-28.5-12.1-26.8-61-36v-25.5c73.9 2.4 255.9 8.6 363-3.8-3.5 38.3-7.8 126.5-7.8 126.5h-23.2c-11.1-42.8-18.8-90.5-54.8-90.5h-137c-10.3 0-10.8 3.5-10.8 9.8v163.8c58 0.5 88.5-2.5 88.5-2.5 29.8-1 27.6-8.5 40.8-65.3h25.8c-4.4 101.4-3.9 61.8-1.8 160.3h-25.8c-9.2-40.1-9.1-61-39.5-61.5 0 0-21.5-2-88-2v139c0 26 14.3 38.3 44.3 38.3h89.3c63.6 0 66.6-25 98.8-99.8h22.2v0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/etsy.js
// module id = 813
// module chunks = 0